const _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f2d2ad7c3688ae049493f5a01feb0aa1bfcc5bc6"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["web-frontend@codingal-inc"]={id:"f2d2ad7c3688ae049493f5a01feb0aa1bfcc5bc6"};
      